(() => {
  const initializeProduct = root => {
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const form = select.closest('form');
        const available = option.dataset.available === 'true';
        const button = form.querySelector('[data-add-to-cart]');
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
        form.closest('.product-info').querySelector('[data-product-price]').textContent = option.dataset.price;
        const quantity = form.querySelector('[name="quantity"]');
        const rule = JSON.parse(option.dataset.quantityRule || '{}') || {};
        quantity.min = rule.min || 1;
        quantity.step = rule.increment || 1;
        quantity.value = rule.min || 1;
        if (rule.max != null) quantity.max = rule.max; else quantity.removeAttribute('max');
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    });
  };
  initializeProduct(document);
  document.addEventListener('shopify:section:load', event => initializeProduct(event.target));
})();
